export default __webpack_public_path__ + "static/media/indexxfortune.4a8c4215.png";